let productDetails;
const parser = new DOMParser();

const main = document.querySelector("#MainContent");

main.addEventListener("click", (e) => {
  const anchor = e.target.closest(".product-variant-swatches a");
  if (!anchor) return;
  e.preventDefault();

  if (anchor.dataset.opticalClipon === "true") {
    const root = document.getElementById("optical-clipon-swatches");
    const framePart = root ? root.dataset.framePartHandle || "" : "";
    const cliponHandle = anchor.dataset.cliponHandle || "";
    const cliponVariantId = anchor.dataset.cliponVariantId || "";

    document.querySelectorAll(".clipons-swatches a").forEach((el) => {
      el.classList.remove("active");
    });
    anchor.classList.add("active");

    const hidden = document.getElementById("selected_clipon_variant_id");
    if (hidden) hidden.value = cliponVariantId;

    const label = document.querySelector(
      "#optical-clipon-swatches .clipon-variant-label"
    );
    if (label && anchor.dataset.cliponLabel) {
      label.textContent = anchor.dataset.cliponLabel;
    }

    if (
      typeof window.initOpticalCliponGallerySlides === "function" &&
      cliponHandle
    ) {
      window.initOpticalCliponGallerySlides(framePart || "", cliponHandle);
    }

    if (
      typeof window.initOpticalCliponVTOSlides === "function" &&
      cliponHandle
    ) {
      window.initOpticalCliponVTOSlides(framePart || "", cliponHandle);
    }

    syncOpticalCliponCta(anchor, root);
    updateURL(anchor.dataset.url || window.location.pathname);
    return;
  }

  updateVariantRadio(anchor);
  disableButton();
  updateURL(anchor.dataset.url);
  fetchProductDetails(anchor.dataset.url, anchor.dataset.section);
});

function syncOpticalCliponCta(anchor, root) {
  const outOfStock = anchor.classList.contains("not-available");
  const selectLenses = document.querySelector(".new-prescription-toggle-container");
  const waitlist = document.querySelector(".join-waitlist-container");

  setPdpCtaActive(selectLenses, !outOfStock);
  setPdpCtaActive(waitlist, outOfStock);

  if (!outOfStock || !waitlist) return;

  const productId = root?.dataset.cliponProductId;
  const variantId = anchor.dataset.cliponVariantId;
  const waitlistBtn = document.getElementById("join_waitlist");
  if (waitlistBtn && productId && variantId) {
    waitlistBtn.setAttribute(
      "onclick",
      `openWaitlistModal(${productId}, ${variantId})`
    );
  }
}

function setPdpCtaActive(el, active) {
  if (!el) return;
  el.classList.toggle("cta-inactive", !active);
  if (active) el.style.display = "";
}

function updateVariantRadio(target) {
  document.querySelectorAll(".product-variant-swatches a").forEach((element) => {
    element.classList.remove("active");
    target.classList.add("active");
  });
}

function disableButton() {
  document
    .querySelectorAll(".product-details .Product__header form button")
    .forEach((btn) => {
      btn.setAttribute("disabled", "");
    });
}

function updateURL(url) {
  console.log("url", url);
  history.pushState({}, "", url);
}

async function fetchProductDetails(url, section) {
  const fullUrl = url /*+ '&section_id=' + section*/;

  fetch(fullUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.text();
    })
    .then((data) => {
      updateProductDetails(data);
      updateGallery(data);
      updatePrescription(data);
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });
}

function updateProductDetails(data) {
  const doc = parser.parseFromString(data, "text/html");
  const productDetailsHeader = document.querySelector(
    ".product-details .Product__header form"
  );
  const newProductDetailsHeader = doc.querySelector(
    ".product-details .Product__header form"
  );
  productDetailsHeader.replaceWith(newProductDetailsHeader);

  const productVTOContainer = document.querySelector(".desktop-product-vto-container");
  const newproductVTOContainer = doc.querySelector(".desktop-product-vto-container");
  productVTOContainer.replaceWith(newproductVTOContainer);
  sizeGuide();

  const productDescription = document.querySelectorAll(
    "#product-description-accordion li"
  );
  const newproductDescription = doc.querySelectorAll(
    "#product-description-accordion li"
  );

  const productInfo = document.querySelector(".product-infomation-header");
  const newproductInfo = doc.querySelector(".product-infomation-header");
  productInfo.replaceWith(newproductInfo);

  try {
    productDescription[0].replaceWith(newproductDescription[0]);
  } catch (error) {}
}

function updateGallery(data) {
  if (typeof window.destroyProductGallerySwiper === "function") {
    window.destroyProductGallerySwiper();
  }

  const productGallery = document.querySelectorAll(".product-gallery-swipper");
  const doc = parser.parseFromString(data, "text/html");
  const newProductGallery = doc.querySelectorAll(".product-gallery-swipper");
  productGallery.forEach((element, index) => {
    element.replaceWith(newProductGallery[index]);
  });

  const newGalleryRoot = doc.querySelector("#product-gallery-container");
  const oldGalleryRoot = document.querySelector("#product-gallery-container");
  if (newGalleryRoot && oldGalleryRoot) {
    oldGalleryRoot.setAttribute(
      "data-product-sku",
      newGalleryRoot.getAttribute("data-product-sku")
    );
  }

  window.__opticalCliponSlidePool = null;
  window.__opticalCliponVTOSlidePool = null;

  try {
    if (
      newGalleryRoot &&
      newGalleryRoot.getAttribute("data-optical-clipon-gallery") === "true" &&
      typeof window.initOpticalCliponGallerySlides === "function"
    ) {
      const frameH =
        newGalleryRoot.getAttribute("data-frame-part-handle") || "";
      const clipH =
        newGalleryRoot.getAttribute("data-initial-clipon-handle") || "";
      window.initOpticalCliponGallerySlides(frameH, clipH);
      if (typeof window.initOpticalCliponVTOSlides === "function") {
        window.initOpticalCliponVTOSlides(frameH, clipH);
      }
    } else {
      loadGallerySwiper();
      initializeVTOGallerySwiper();
      initializeVTO();
    }
  } catch (error) {}
}

function updatePrescription(data) {
  const doc = parser.parseFromString(data, "text/html");
  try {
    const productPrescriptionInput = document.querySelector(
      ".new-toggle-prescription input"
    );
    const newProductPrescriptionInput = doc.querySelector(
      ".new-toggle-prescription input"
    );
    productPrescriptionInput.replaceWith(newProductPrescriptionInput);

    const productPrescriptionSection = document.querySelector(
      ".new-toggle-prescription section"
    );
    const newProductPrescriptionSection = doc.querySelector(
      ".new-toggle-prescription section"
    );
    productPrescriptionSection.replaceWith(newProductPrescriptionSection);

    loadPrescription();
  } catch (error) {}
}

function sizeGuide() {
  const modal = document.getElementById("sizeGuideModal") || "";
  const triggerBtn = document.querySelector(".size-guide-modal-trigger") || "";
  const closeBtn = document.querySelector(".size-guide-modal__close") || "";

  triggerBtn.onclick = function () {
    modal.style.display = "block";
  };

  closeBtn.onclick = function () {
    modal.style.display = "none";
  };

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  const modal1 = $("#sizeGuideModalDynamic") || "";
  const triggerBtn1 = $(".size-guide-modal-trigger--dynamic") || "";
  const closeBtn1 = $(".size-guide-modal__close--dynamic") || "";

  triggerBtn1.on("click", function () {
    modal1.show();
  });

  closeBtn1.on("click", function () {
    modal1.hide();
  });

  $(document).on("click", function (event) {
    if (event.target.id == modal1.attr("id")) {
      modal1.hide();
    }
  });
}
